export default "__VITE_ASSET__CK10ViPG__"